
<modal
  title="Apply gift card"
  :open="open"
  @close="closeModal"
>
  <form @submit.prevent="submit">
    <p class="small-text">
      Please note Gift Cards are only eligible for use on Card Ladder memberships. This GiftCard cannot be combined for use with additional products (i.e. Collectors Club Premium). If you have any questions, please contact Kristina at contact@cardladder.com for more information.
    </p>

    <text-input
      id="giftcardcode"
      v-model.trim="giftCardCode"
      type="text"
      label="Gift Card Code"
    />

    <p v-if="error" class="error">
      {{ error }}
    </p>
    <p v-if="checking" class="success">
      Checking...
    </p>
    <p v-if="response && response.remainingValue" class="success">
      Available balance of {{ $filters.currency(response.remainingValue) }}
    </p>

    <btn type="submit" :disabled="response === null">
      Apply
    </btn>
  </form>
</modal>
